module.exports = __webpack_public_path__ + "static/media/dark_mode.ea815880.png";